import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, isValidElement, useMemo, } from 'react';
import MuiSnackbarContent from '@material-ui/core/SnackbarContent';
import { combineClasses, isRcElement, styled, useDeprecatedCheck, useThemeProps, } from '../../../foundation';
import { RcCircularProgress } from '../../Progress/CircularProgress';
import { snackbarContentStyle } from './styles';
import { RcSnackbarContentClasses, RcSnackbarContentLoadingSizes, } from './utils';
/** @release */
var _RcSnackbarContent = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcSnackbarContent' });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcSnackbarContent, props, [
            {
                prop: 'ariaLabel',
                time: '2021-3',
                comment: "please use `aria-label` directly ",
            },
        ]);
    }
    var classesProp = props.classes, loading = props.loading, size = props.size, messageAlign = props.messageAlign, type = props.type, fullWidth = props.fullWidth, actionProp = props.action, rest = __rest(props, ["classes", "loading", "size", "messageAlign", "type", "fullWidth", "action"]);
    var classes = useMemo(function () { return combineClasses(RcSnackbarContentClasses, classesProp); }, [classesProp]);
    var action = useMemo(function () {
        var getItem = function (item) {
            if (isValidElement(item) && isRcElement(item, ['RcSnackbarAction'])) {
                /** when size is not equal default size, that mean user want to custom size */
                if (size !== RcSnackbarContent.defaultProps.size) {
                    return item;
                }
                return React.cloneElement(item, { size: size });
            }
            return item;
        };
        if (actionProp instanceof Array) {
            return actionProp.map(getItem);
        }
        return getItem(actionProp);
    }, [actionProp, size]);
    return (React.createElement(MuiSnackbarContent, __assign({}, rest, { ref: ref, classes: classes, action: loading ? (React.createElement(RcCircularProgress, { color: "inherit", size: RcSnackbarContentLoadingSizes[size] })) : (action) })));
});
var RcSnackbarContent = styled(_RcSnackbarContent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), snackbarContentStyle);
RcSnackbarContent.defaultProps = {
    type: 'success',
    messageAlign: 'center',
    size: 'medium',
};
RcSnackbarContent.displayName = 'RcSnackbarContent';
export { RcSnackbarContent };
var templateObject_1;
